<div class="header">
    <div class="logo logo-dark">
        <a href="">
          <div class="m-t-20">
            Robo Admin
          </div>
        </a>
    </div>
    <div class="nav-wrap">
        <ul class="nav-left">
            <li class="desktop-toggle">
                <a (click)="toggleFold()">
                    <i nz-icon [nzType]="isFolded? 'menu-unfold':'menu-fold'" theme="outline"></i>
                </a>
            </li>
            <li class="mobile-toggle">
                <a (click)="toggleExpand()">
                    <i nz-icon [nzType]="isExpand? 'menu-fold': 'menu-unfold'" theme="outline"></i>
                </a>
            </li>
        </ul>
        
        <ul class="nav-right">
<!--            <li>-->
<!--              <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="popNotification" [nzPlacement]="'bottomRight'">-->
<!--                <nz-badge nzDot>-->
<!--                  <i nz-icon nzType="bell" theme="outline"></i>-->
<!--                </nz-badge>-->
<!--              </a>-->
<!--              <nz-dropdown-menu #popNotification="nzDropdownMenu">-->
<!--                <div nz-menu class="pop-notification">-->
<!--                  <div class="p-v-15 p-h-25 border-bottom d-flex justify-content-between align-items-center">-->
<!--                    <p class="text-dark font-weight-semibold m-b-0">-->
<!--                      <i nz-icon nzType="bell" theme="outline"></i>-->
<!--                      <span class="m-l-10">Notification</span>-->
<!--                    </p>-->
<!--                    <a nz-button nz-button nzSize="small" class="p-v-5" [routerLink]="''">-->
<!--                      <small>View All</small>-->
<!--                    </a>-->
<!--                  </div>-->
<!--                  <div class="overflow-y-auto" style="max-height: 300px">-->
<!--                    <nz-list class="ant-list-item-links" [nzDataSource]="notificationList" [nzRenderItem]="item" [nzItemLayout]="'horizontal'">-->
<!--                      <ng-template #item let-item>-->
<!--                        <nz-list-item>-->
<!--                          <a [routerLink]="''">-->
<!--                            <div class="d-flex">-->
<!--                              <nz-avatar [nzIcon]="item.icon" [ngClass]="item.color"></nz-avatar>-->
<!--                              <div class="m-l-15">-->
<!--                                <p class="m-b-0 text-dark">{{item.title}}</p>-->
<!--                                <p class="m-b-0"><small>{{item.time}} ago</small></p>-->
<!--                              </div>-->
<!--                            </div>-->
<!--                          </a>-->
<!--                        </nz-list-item>-->
<!--                      </ng-template>-->
<!--                    </nz-list>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </nz-dropdown-menu>-->
<!--            </li>-->
            <li>
                <span class="p-h-10 pointer" nz-dropdown [nzDropdownMenu]="profile" [nzTrigger]="'click'" [nzPlacement]="'bottomRight'">
                    <nz-avatar [nzSize]="32" nzIcon="user" style="background-color:#87d068;"></nz-avatar>
                </span>
                <nz-dropdown-menu #profile="nzDropdownMenu">
                    <ul nz-menu class="p-b-15 p-t-20">
                        <li class="p-h-20 p-b-15 m-b-10 border-bottom">
                            <div class="d-flex m-r-50">
<!--                                <nz-avatar [nzSize]="48" nzIcon="user"></nz-avatar>-->
                                <div class="m-l-10">
                                    <p class="m-b-0 text-dark font-weight-semibold">{{currentUser?.login}}</p>
                                    <p class="m-b-0 opacity-07">{{currentUser?.email}}</p>
                                </div>
                            </div>
                        </li>
                        <li nz-menu-item>
                          <a class="p-v-5 d-flex align-items-center justify-content-between" [routerLink]="['/account/profile']">
                            <div>
                              <i class="opacity-04 font-size-16" nz-icon nzType="user" theme="outline"></i>
                              <span class="m-l-10">Profile</span>
                            </div>
                            <i class="font-size-10" nz-icon nzType="right" theme="outline"></i>
                          </a>
                        </li>
                        <li nz-menu-item>
                            <a class="p-v-5 d-flex align-items-center justify-content-between">
                                <div>
                                    <i class="opacity-04 font-size-16" nz-icon nzType="logout" theme="outline"></i>
                                    <span class="m-l-10" (click)="logout()">Logout</span>
                                </div>
                                <i class="font-size-10" nz-icon nzType="right" theme="outline"></i>
                            </a>
                        </li>
                    </ul>
                </nz-dropdown-menu >
            </li>
        </ul>
    </div>
</div>
